import { ActionTypes } from '../../constants/ActionTypes';
import { ILoginModel, ISigninModel } from '../../interfaces';

export const userSignUp = (user: ILoginModel) => {
  return {
    type: ActionTypes.SIGNUP_USER,
    payload: user,
  };
};

export const userSignIn = (user: ILoginModel) => {
  return {
    type: ActionTypes.SIGNIN_USER,
    payload: user,
  };
};

export const userSignOut = () => {
  return {
    type: ActionTypes.SIGNOUT_USER,
  };
};

export const userSignInSuccess = (authUser: ISigninModel) => {
  return {
    type: ActionTypes.SIGNIN_USER_SUCCESS,
    payload: authUser,
  };
};

export const userSignOutSuccess = () => {
  return {
    type: ActionTypes.SIGNOUT_USER_SUCCESS,
  };
};

export const showAuthMessage = (message: string) => {
  return {
    type: ActionTypes.SHOW_MESSAGE,
    payload: message,
  };
};

export const setInitUrl = (url: string) => {
  return {
    type: ActionTypes.INIT_URL,
    payload: url,
  };
};

export const showAuthLoader = () => {
  return {
    type: ActionTypes.ON_SHOW_LOADER,
  };
};

export const hideAuthLoader = () => {
  return {
    type: ActionTypes.ON_HIDE_LOADER,
  };
};
